import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './Attributes.module.css'
import styleNames from '../../utils/styleNames'

import { Select, NumberSelect } from '../index'

export default class Attributes extends Component {
  static propTypes = {
    attributes: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.bool
    })),
    disabled: PropTypes.bool,
    onNumberSelectPressed: PropTypes.func,
    onToggleCheckbox: PropTypes.func
  }
  static defaultProps = {
    attributes: []
  }

  _renderSelect (attribute, i) {
    if (attribute.numberSelect) {
      return (
        <div key={`select_${i}`} className={styleNames(styles, `${this.props.disabled ? 'disabled' : ''} attribute`)}>
          <NumberSelect
            checked={this.props.disabled ? false : attribute.checked}
            disabled={this.props.disabled}
            name={attribute.name}
            onClick={this.props.onNumberSelectPressed.bind(this, attribute.name)}
            value={attribute.numberSelect.value} />
          <label>
            {attribute.label}
          </label>
        </div>
      )
    }
    else {    
      return (
        <div key={`select_${i}`} className={styleNames(styles, `${this.props.disabled ? 'disabled' : ''} attribute`)}>
          <Select
            checked={this.props.disabled ? false : attribute.checked}
            disabled={this.props.disabled}
            name={attribute.name}
            onClick={this.props.onToggleCheckbox.bind(this, attribute.name)} />
          <label>
            {attribute.label}
          </label>
        </div>
      )
    }
  }

  render () {
    return (
      <div className={styles['attributes-container']}>
        <div className={styles.row}>
          <h2>Tillval<span>{this.props.disabled ? 'Inte tillgängligt för business, välj taxi eller storbil' : ''}</span></h2>
        </div>
        <div className={styles['attributes-wrapper']}>
          {this.props.attributes.map((attribute, i) => this._renderSelect(attribute, i))}
        </div>
      </div>
    )
  }
}
